import React from "react";
import { BsTwitter } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer p-4">
      <div className="container px-5">
        <div className="mx-auto d-flex flex-column flex-lg-row justify-content-center align-items-center">
          {/* <div className="footer-text mb-2">Loser Ape Club</div> */}
          {/* <div className="img mb-2">
            <img
              // src="https://cryptomories.iwwon.com/images/tetesolo.png"
              src={logo2}
              alt=""
              className="img-fluid"
              width="90px"
              className="img-fluid"
            />
          </div> */}
          <div className="icon-part d-flex mt-2">
            {/* <div className=" mx-3">
              <a
                href="https://opensea.io/collection/loserapeclub"
                target="_blank"
              >
                <img
                  src={opensea}
                  alt=""
                  className="social-icon img-fluid"
                  width="25px"
                />
              </a>
            </div> */}

            <div className="twitter mx-3">
              <a href="https://twitter.com/MousInDaRightH" target="_blank">
                <BsTwitter className="social-icon" />
              </a>
            </div>
            <div className="discord mx-3">
              <a href="https://discord.gg/aetBpbpayx" target="_blank">
                <FaDiscord className="social-icon" />
              </a>
            </div>
            {/* <div className="instagram mx-3">
              <a
                href="https://www.instagram.com/loserapeclubnft"
                target="_blank"
              >
                <AiOutlineInstagram className="social-icon" />
              </a>
            </div> */}
            {/* <div className="medium mx-3">
              <a href="https://medium.com/@LoserApeClub" target="_blank">
                <AiOutlineMedium className="social-icon" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
